import React, { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { connect } from "react-redux";
import genericProfilePic from "../genericprofilepic.png";

function OthersCommentary(props) {
  const userId = localStorage.getItem("user_id");
  const [chapterCommentary, setChapterCommentary] = useState([]);
  const [users, setUsers] = useState([]);
  const [showCommentary, setShowCommentary] = useState(false);

  useEffect(() => {
    if (!showCommentary) return;

    const fetchData = async () => {
      const [commSnap, usersSnap] = await Promise.all([
        getDocs(
          query(
            collection(db, 'commentaries'),
            where('book', '==', props.book),
            where('chapter', '==', props.chapter)
          )
        ),
        getDocs(collection(db, 'users')),
      ]);
      setChapterCommentary(commSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      setUsers(usersSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    };

    fetchData();
  }, [props.book, props.chapter, showCommentary]);

  const filteredCommentary = chapterCommentary.filter(
    (commentary) => commentary.user_id !== userId
  );

  return (
    <div>
      <div>
        {showCommentary ? (
          <div>
            <button
              id="bigbutton"
              onClick={() => {
                setShowCommentary(!showCommentary);
              }}
            >
              Hide What Others Are Saying
            </button>

            {filteredCommentary.length === 0 && (
              <p className="commentary-text">No one else has commented on this chapter yet.</p>
            )}
            {filteredCommentary.map((commentary) => {
              const user = users.find(user => user.id === commentary.user_id);
              if (user) {
                return (
                  <div key={commentary.id} className="roundedbox">
                    <div className="commentary-text">
                      <img
                        id="smallprofilepic"
                        src={user.profile_pic_url || genericProfilePic}
                        alt={`${user.first_name} ${user.last_name}'s profile`}
                      />
                      <br />
                      <b>
                        {user.first_name} {user.last_name} wrote:
                      </b>
                    </div>
                    <p className="commentary-text">
                      {commentary.commentary}
                    </p>
                  </div>
                );
              }
              return null;
            })}
          </div>
        ) : (
          <button
            id="bigbutton"
            onClick={() => {
              setShowCommentary(!showCommentary);
            }}
          >
            See What Others Are Saying
          </button>
        )}
      </div>
      <br />
      <br />
      <br />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
    profile_pic_url: state.profile_pic_url,
  };
};

export default connect(mapStateToProps, {})(OthersCommentary);
